import React from 'react';
import { ThemeProvider } from '@material-ui/core';
import appTheme from './App.theme';

function HAPThemeProvider({ children }) {
  return <ThemeProvider theme={appTheme}>{children}</ThemeProvider>;
}

export default HAPThemeProvider;
